import React, { useEffect, useState } from 'react'
import {
  Box,
  CircularProgress,
  Grid,
  Modal,
  styled,
  Typography,
  Button,
  DialogActions,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { BorderButtonPurple, CustomButton, GradientButton, OutlineButton } from '../buttons'
import lightTheme from '../../styles/theme/lightTheme'
import '../../styles/components/_box.scss'
import '../../styles/components/_grids.scss'
import '../../styles/components/_inputs.scss'
import Api from '../../services/api.service'
import { handlingErrors } from '../../utils'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { userLogout } from '../../store/slices/userAuthReducer'
import TextareaInputClassic from '../inputs/TextareaInputClassic'
import { ROLE_ENTREPRISE } from '../../data'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'

const ModalContainer = styled(Box)(({ theme }) => ({
  width: 'calc(100% - 50px)',
  height: 650,
  backgroundColor: '#FFFFFF',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  rowGap: '20px',

  '&:focus-visible': {
    outline: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    width: 700,
    /*height: 500,*/
    height: 'auto',
    rowGap: '35px',
  },
}))

const BoxContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 500,
  backgroundColor: lightTheme.palette.primary.b6,
  padding: '20px',

  [theme.breakpoints.up('sm')]: {
    /*height: 300,*/
    height: 'auto',
  },
}))

/* const proSchema = yup.object({
  commentaire: yup.string().required('Merci de renseigner ce champ.'),
}) */

const parSchema = yup.object({
  commentaire: yup.string().required('Merci de renseigner ce champ.'),
})

const EditCommentaire = ({ open, onClose, onSave, id, role }) => {
  const { t, i18n } = useTranslation()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  /*  const [commentaire, setCommentaire] = useState('')
   const [snapShot, setSnapShot] = useState(null) */
  const {
    register,
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(parSchema),
  })

  useEffect(() => {
    fetchData()
  }, [id, dispatch, reset])

  const fetchData = async () => {
    try {
      let result = await Api.user.detail(id)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        console.log('erreur')
      }

      if (handling.ok) {
        const res = handling.data
        /* setSnapShot(res)
        setCommentaire(res.commentaire) */
        reset(res)
      }
    } catch (error) {
      console.log(error)
    }
  }


  const onSubmit = async (data) => {
    setLoading(true)

    //return

    const {
      admin,
      candidat,
      userOffres,
      date,
      entreprise,
      lang,
      offre,
      parent,
      password,
      status,
      ...rest
    } = data

    try {
      const result = await Api.user.edit(id, { commentaire: data.commentaire })
      const handling = handlingErrors(result)

      if (handling.status === 401) {
        dispatch(userLogout())
        return
      }

      if (handling.ok) {
        //const res = handling.data
        setLoading(false)
        onSave()
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.log('erreur submit !')
    }
  }


  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (

    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      scroll={'paper'}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '16px',
          p: fullScreen ? 0 : '8px',
          m: fullScreen ? 0 : undefined,
          maxHeight: fullScreen ? '100%' : '90vh',
          ...(fullScreen && {
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
          px: { xs: 2, sm: 3 },
          py: { xs: 1.5, sm: 2 },
          pb: 2,
          flexShrink: 0,
          borderBottom: '1px solid rgba(229, 231, 235, 0.8)',
          backgroundColor: 'rgba(249, 250, 251, 0.5)',
        }}
      >
        <Typography
          variant={fullScreen ? 'subtitle1' : 'h6'}
          sx={{
            fontWeight: 600,
            color: '#1f2937',
            pr: 1,
            lineHeight: 1.3,
            wordBreak: 'break-word',
          }}
        >
          Modifier le commentaire
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#6b7280',
            flexShrink: 0,
            '&:hover': {
              backgroundColor: 'rgba(107, 114, 128, 0.1)',
              color: '#374151',
            },
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 2, sm: 3 },
          pt: { xs: '16px !important', sm: '32px !important' },
          flex: fullScreen ? 1 : undefined,
          overflow: 'auto',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }}
          >
            <TextareaInputClassic
              placeholder={'Commentaires Jobertech'}
              width={'100%'}
              register={{ ...register('commentaire') }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      {/*<Box className={"wrapperButtons"} width={"100%"}>*/}
      <DialogActions
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 2, sm: 3 },
          gap: 2,
          justifyContent: 'center',
          backgroundColor: 'rgba(249, 250, 251, 0.8)',
          borderTop: '1px solid rgba(229, 231, 235, 0.8)',
          flexDirection: { xs: 'column', sm: 'row' },
          flexShrink: 0,
          '& > *': {
            width: { xs: '100%', sm: 'auto' },
            m: 0,
          },
        }}
      >
        <OutlineButton onClick={onClose} fullWidth={fullScreen}>
          {t('button.cancel')}
        </OutlineButton>

        <GradientButton
          onClick={handleSubmit(onSubmit)}
          fullWidth={fullScreen}
        >
          {loading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1, color: 'white' }} />
              {t('profile.saving')}
            </>
          ) : (
            t('button.save')
          )}
        </GradientButton>
      </DialogActions>
    </Dialog>
  )
}

export default EditCommentaire
